<template>
	<div>
		<div v-if="message.group_id === null && isRead" class="read-status readed">{{ $t("chatMessageReadStatus.haveRead") }}</div>
		<div v-if="message.group_id === null && !isRead" class="read-status unread">{{ $t("chatMessageReadStatus.unread") }}</div>
		<div v-if="message.group_id !== null" class="group-read-status" @click="handleGroupReadStatus" :class="{ loading: loading }">
			{{ $t("chatMessageReadStatus.readingStatus") }}
		</div>
	</div>
</template>

<script>
import { getGroupReadStatus } from "@/services/api-v2/api-v2";
import _ from "lodash";
import { isBefore } from "@/utils/date";

export default {
	name: "ChatMessageReadStatus",

	props: {
		message: {
			type: Object,
			require: true,
		},
		conversation: {
			type: Object,
			require: true,
		},
	},

	data() {
		return {
			loading: false,
		};
	},

	methods: {
		// 群组阅读状态弹窗
		async handleGroupReadStatus() {
			if (this.loading) {
				return;
			}

			this.loading = true;

			try {
				const { data } = await getGroupReadStatus(this.message.id);

				const htmlBodyArray = _.map(data, (item) => {
					if (item.is_read) {
						return `<li> ${item.nick_name} <span style="color:#33CC66">(${this.$t("chatMessageReadStatus.haveRead")})</span></li>`;
					} else {
						return `<li> ${item.nick_name} <span style="color:#CC0033">(${this.$t("chatMessageReadStatus.unread")})</span></li>`;
					}
				});

				const htmlContent = '<ul style="list-style:none;">' + htmlBodyArray.join("") + "</ul>";

				this.$alert(htmlContent, this.$t("chatMessageReadStatus.readingStatus"), {
					dangerouslyUseHTMLString: true,
				});
			} finally {
				this.loading = false;
			}
		},
	},

	computed: {
		isRead: function () {
			return isBefore(this.message.timestamp, this.conversation.last_read_time);
		},
	},
};
</script>

<style lang="less" scoped>
.read-status {
	margin-top: 5px;
	font-size: 12px;
}

.readed {
	color: #acb5c0;
}

.unread {
	color: #608dcc;
}

.group-read-status {
	margin-top: 5px;
	font-size: 12px;
	color: #608dcc;
	cursor: pointer;
}

.loading {
	cursor: wait;
}
</style>
